import { Copy } from '../copy'
import dayjs from '@uswitch/ev-utils/date'
import ImgixImg from '../../elements/imgix-img'
import { useDataSelector } from '@uswitch/ev-utils/context/selectors'
import { Container } from '@uswitch/ev-core/react'

const Author = ({ name, role, photo = {}, publishedAt }) => {
  return (
    <Container sx={{ marginY: [38, 47, 67] }}>
      <div
        sx={{
          display: 'flex',
          flexDirection: ['column', 'row', 'row'],
          width: '100%',
          paddingTop: 'lg',
          borderTop: '1px solid',
          borderColor: 'light-3',
        }}
      >
        <div sx={{ display: 'flex' }}>
          <ImgixImg
            entity={photo}
            width={68}
            height={68}
            sx={{
              width: 68,
              height: 68,
              borderRadius: ({ radii }) => `${radii.lg}px 0`,
            }}
          />

          <div
            sx={{
              marginLeft: 10,
              borderRadius: 'sm',
              overflow: 'hidden',
            }}
          >
            <div
              sx={{
                width: 0,
                height: 0,
                borderStyle: 'solid',
                borderWidth: '26px 26px 0 0',
                borderColor: t => `${t.colors['accent-2']} transparent`,
              }}
            />
          </div>
        </div>

        <div
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-end',
            paddingTop: ['md', 0, 0],
          }}
        >
          <Copy
            as='span'
            sx={{
              color: 'brand',
              lineHeight: 'sm',
              marginBottom: 'xxs',
              fontSize: 'base',
              fontWeight: 'base',
            }}
          >
            {name}
          </Copy>
          <Copy
            as='span'
            sx={{
              lineHeight: 'md',
              fontSize: 'sm',
              color: 'dark-2',
            }}
          >
            <If condition={role}>{role}</If>
            <If condition={role && publishedAt}>{' - '}</If>
            <If condition={publishedAt}>{dayjs(publishedAt).format('MMM Do YYYY')}</If>
          </Copy>
        </div>
      </div>
    </Container>
  )
}

const AuthorConnected = props => {
  const publishedAt = useDataSelector(['pageDates', 'created'])
  return <Author {...props} publishedAt={publishedAt} />
}

export default AuthorConnected
